import { Button, Icon, PagedTable, Tooltip } from 'bold-ui'
import { TableBox } from 'components/table'
import { usePagination } from 'components/table/usePagination'
import React from 'react'
import { HistoricoMedicaoModel } from 'view/atendimentos/types/model-historicoMedicao'

import { renderDataMedicao, renderMedicao } from '../render-medicoes'
import { getMedicaoAnteriorActionTooltip } from '../util-medicoes'
import { getForcaMuscularRenderText } from './utils-medicaoAnteriorExameFisico'

interface HistoricoMedicoesExameFisicoTableProps {
  medicoes: ReadonlyArray<HistoricoMedicaoModel>
  isAtendimentoObservacao: boolean
  onRemove?: (id: ID) => void
}

export function HistoricoMedicoesExameFisicoTable(props: Readonly<HistoricoMedicoesExameFisicoTableProps>) {
  const { medicoes, isAtendimentoObservacao, onRemove } = props

  const { paginatedItems, tableProps } = usePagination({
    items: [...medicoes],
    initialPageSize: 5,
  })

  const renderActions = (row: HistoricoMedicaoModel) => {
    return (
      <Tooltip text={getMedicaoAnteriorActionTooltip(row, isAtendimentoObservacao)}>
        <Button
          kind='normal'
          skin='ghost'
          size='small'
          onClick={() => onRemove?.(row.id)}
          disabled={row.origem !== 'medicoesAnteriores'}
        >
          <Icon icon='trashOutline' />
        </Button>
      </Tooltip>
    )
  }

  return (
    <TableBox>
      <PagedTable<HistoricoMedicaoModel>
        {...tableProps}
        rows={paginatedItems}
        size={tableProps.pageSize}
        columns={[
          {
            header: 'Data da medição',
            name: 'dataMedicao',
            render: renderDataMedicao,
            style: { width: '5rem' },
          },
          {
            header: 'Força muscular mão direita',
            name: 'valorForcaMuscMaoDireita',
            render: renderMedicao((med) =>
              getForcaMuscularRenderText(med.valorForcaMuscMaoDireita, med.unidadeForcaMuscMaoDireita)
            ),
            style: { width: '6rem' },
          },
          {
            header: 'Força muscular mão esquerda',
            name: 'valorForcaMuscMaoEsquerda',
            render: renderMedicao((med) =>
              getForcaMuscularRenderText(med.valorForcaMuscMaoEsquerda, med.unidadeForcaMuscMaoEsquerda)
            ),
            style: { width: '6rem' },
          },
          {
            name: 'buttons',
            render: renderActions,
            style: { textAlign: 'right', width: '3.5rem' },
          },
        ]}
      />
    </TableBox>
  )
}
